import React, { useEffect, useState } from "react";
import logo from "../../../assets/Logo/FBX_2024_alone.svg";
import "./supportAnnouncement.style.scss";

const STORAGE_KEY = "FBX_HIDE_QUICK_NOTES_ANNOUNCEMENT";

const QuickNotesAnnouncement = ({ show = false }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!show) {
            setVisible(false);
            return;
        }

        try {
            setVisible(localStorage.getItem(STORAGE_KEY) !== "Yes");
        } catch {
            setVisible(true);
        }
    }, [show]);

    const dismissThisTime = () => {
        setVisible(false);
    };

    const dismissForGood = () => {
        try {
            localStorage.setItem(STORAGE_KEY, "Yes");
        } catch {}
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="support-announcement-backdrop quick-notes-announcement-backdrop" role="dialog" aria-modal="true">
            <div className="support-announcement quick-notes-announcement">
                <div className="support-announcement__brand quick-notes-announcement__brand">
                    <img src={logo} alt="FBX" />
                    <div>
                        <h2>Introducing Quick Notes</h2>
                    </div>
                </div>

                <div className="support-announcement__body quick-notes-announcement__body">
                    <div className="support-announcement__button-preview quick-notes-announcement__button-preview">
                        <span>QN</span>
                    </div>

                    <div className="support-announcement__copy">
                        <p>
                            Quick Notes let you create a quick note about a player without creating
                            a full Note in the Notes area. Quick Notes are shared with every member
                            of your team.
                        </p>
                        <p>
                            To make one, press <strong>QN</strong> beside Files, or press the green
                            icon in the last column of the one liner for a player who already has a
                            Quick Note.
                        </p>
                        <p>
                            To see all Quick Notes for your team, turn on <strong>Quick Notes</strong>
                            in S1 Search with no other fields filled in.
                        </p>
                    </div>
                </div>

                <div className="support-announcement__actions">
                    <button type="button" className="btn btn-outline-secondary" onClick={dismissThisTime}>
                        Dismiss This Time
                    </button>
                    <button type="button" className="btn btn-primary" onClick={dismissForGood}>
                        Dismiss for Good
                    </button>
                </div>
            </div>
        </div>
    );
};

export default QuickNotesAnnouncement;
